<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="returnOrder.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1100px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="returnOrder"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="申请编号">
            <el-input v-model="returnOrder.returnOrderNo" readonly placeholder="系统自动生成"/>
          </el-form-item>
          <el-form-item label="申请人">
            <el-input v-model="returnOrder.creatorName" readonly placeholder="系统自动生成"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="申请时间">
            <el-input v-model="returnOrder.createTime" readonly placeholder="系统自动生成"/>
          </el-form-item>
          <el-form-item label="申请部门">
            <el-input v-model="returnOrder.departmentName" readonly placeholder="系统自动生成"/>
          </el-form-item>
        </div>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectSalesOrder.open()">
              新建
            </el-button>
            <sales-order-select ref="selectSalesOrder" @select="addDetails"/>
          </div>
          <el-table
              :data="returnOrder.details"
              border>
            <el-table-column prop="factoryNo" width="100" align="center" label="出厂编号"/>
            <el-table-column prop="customerName" width="110" align="center" label="客户名称"/>
            <el-table-column prop="materialNo" width="100" align="center" label="物料编号"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="reason" width="200" align="center" label="退货理由">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.reason"
                    placeholder="请输入退货理由"
                    autosize
                    type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" width="150" align="center" label="数量">
              <template slot-scope="scope">
                <el-input-number
                    v-model="scope.row.quantity"
                    :precision="2"
                    :step="1"
                    placeholder="请输入数量"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="100px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSave">保存</el-button>
        <el-button :loading="submitLoading" type="success" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import auth from "@/util/loginUtil";
  import SalesOrderSelect from "@/views/salesManage/salesOrder/SalesOrderSelect";

  export default {
    name:"ReturnOrderEdit",
    components: {SalesOrderSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        selection: [],
        returnOrder: {
          pkid: "",
          billNo: "",
          isSubmit: false,
          creatorName: auth.getName(),
          details:[],
        },
        ruleValidate: {
          // cause: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.returnOrder.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.$nextTick(() => {
            this.getData();
          });
        }
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo/10)-1);
        }
      },
      getDetails(row, index) {
        console.log(row,index);
        this.returnOrder.details[index].materialId = row.id;
        this.returnOrder.details[index].materialName = row.name;
        this.returnOrder.details[index].materialNo = row.no;
      },
      addDetails(row) {
        console.log(row);
        this.returnOrder.details.push({
          pkid: 0,
          factoryNo: row.factoryNo,
          customerName: row.customerName,
          salesOrderId: row.salesOrderID,
          salesOrderMaterialRowIndex: row.rowNO,
          quantity: row.quantity,
          materialNo: row.materialNO,
          materialName: row.materialName,
        });
      },
      oneDelete(index) {
        this.returnOrder.details.splice(index, 1);
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.returnOrder.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.returnOrder.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      getData() {
        this.$http
          .get("basic", `returnOrders/${this.returnOrder.pkid}`)
          .then(resp => {
            this.returnOrder = resp;
            // this.returnOrder.attachments.forEach(row=>{
            //   if(row.filePath.includes("common")) {
            //     row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
            //     this.imgUrls.push(row.imgUrl);
            //   }else {
            //     row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
            //     this.imgUrls.push(row.imgUrl);
            //   }
            // });
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      // beforeAvatarUpload(file) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.returnOrder.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      getArrDifference(arr1) {
        let arr2= [0,1,2,3,4,5,6,7,8];
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v);
        });
      },
      handleSubmit() {
        this.returnOrder.isSubmit = true;
        if(this.returnOrder.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSave() {
        if(this.returnOrder.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "returnOrders",  this.returnOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "returnOrders", this.returnOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
